import { render, staticRenderFns } from "./crisis-contact.vue?vue&type=template&id=a1f975b8&scoped=true&"
import script from "./crisis-contact.vue?vue&type=script&lang=js&"
export * from "./crisis-contact.vue?vue&type=script&lang=js&"
import style0 from "./crisis-contact.vue?vue&type=style&index=0&id=a1f975b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f975b8",
  null
  
)

export default component.exports